import {AuthService} from '../services';
import {bindLoading} from './index';
import router, {getRouteDefs} from '../routes';

export default {
    namespaced: true,
    state: {
        showFailureMessage: false,
        name: '',
        email: '',
        userId: '',
        roleId: '',
        home: '',
        menus: []
    },
    getters: {
        authenticated(state) {
            return !!state.roleId;
        },
        token(){
            return AuthService.getAuthToken();
        }
    },
    mutations: {

        reloadAuth(state) {
            const {name, roleId, homePageId, userId, email} = AuthService.getAuth();
            const menus = AuthService.getMenus();
            state.showFailureMessage = !!roleId;
            state.userId = userId;
            state.home = (getRouteDefs().find(d => d.name === homePageId) || {path: ''}).path;
            state.name = name;
            state.email = email;
            state.roleId = roleId;
            state.menus.splice(0);
            state.menus = [...menus];
        },
        saveMenu(current, menus) {
            console.log('====== saveMenu =====');
            current.menus = {...menus};
        }
    },
    actions: {
        async authenticate({rootState, commit}, cred) {
            const result = await bindLoading(commit, async () => {
                const authInfo = await AuthService.login(cred);
                commit({type: 'reloadAuth'});
                return authInfo;
            }, 'auth', {exposure: true, delay: 1000});
            return !!result.auth.roleId;
        },

        async authenticateV2({rootState, commit}, cred) {
            const result = await bindLoading(commit, async () => {
                const authInfo = await AuthService.loginV2(cred);
                commit({type: 'reloadAuth'});
                return authInfo;
            }, 'auth', {exposure: true, delay: 1000});
            return !!result.auth.roleId;
        },

        async logout({state}) {
            AuthService.logout();
            state.name = '';
            state.email = '';
            state.userId = '';
            state.home = '';
            state.showFailureMessage = false;
            state.roleId = '';
            state.menus.splice(0);
            await router.replace('/login');
        },
        
        async getMenus({commit, state}) {
            return await bindLoading(commit,
                async () => {
                    const rst = await AuthService.getMenusByRoleId(state.roleId);
                    commit('saveMenu', rst)
                    return rst;
                }, 'auth')
        },
        
        async anonInit({commit}) {
            return await bindLoading(commit,
                async () => {
                    const rst = await AuthService.anonInit(); 
                    commit({type: 'reloadAuth'});
                    return rst;
                }, 'auth')
        }
    }
}